import { render, staticRenderFns } from "./UserTicketList.vue?vue&type=template&id=42e279f7&scoped=true&"
import script from "./UserTicketList.vue?vue&type=script&lang=js&"
export * from "./UserTicketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e279f7",
  null
  
)

export default component.exports